import React from 'react';
import PropTypes from 'prop-types';
import './MultipleButtonSelect.scss';
var formattedStr = function formattedStr(str) {
  return str.toLowerCase().replace(/\s+/g, '-');
};
function MultipleButtonSelect(_ref) {
  var options = _ref.options,
    handleChange = _ref.handleChange,
    selected = _ref.selected;
  return /*#__PURE__*/React.createElement("div", {
    className: "filter-tag-container"
  }, options.map(function (option) {
    return /*#__PURE__*/React.createElement("button", {
      className: "filter-tag ".concat(formattedStr(option), " ").concat(selected.includes(option) ? 'filtertag-selected' : ''),
      name: formattedStr(option),
      id: "tag-".concat(formattedStr(option)),
      onClick: function onClick() {
        return handleChange(option);
      }
    }, option);
  }));
}
MultipleButtonSelect.propTypes = {
  options: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  handleChange: PropTypes.func.isRequired,
  selected: PropTypes.string
};
MultipleButtonSelect.defaultProps = {
  selected: null
};
export default MultipleButtonSelect;